import styled from 'shared/theme'

export const MdmIdGrid = styled.div<{ disabled: boolean }>`
    display: grid;
    grid-template-columns: ${props => (props.disabled ? '50% 50px' : '1fr 50px')};
    column-gap: 0.5rem;
    align-items: flex-start;
`
